import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, {
  useMemo
} from 'react';
import { useRecoilValue } from 'recoil';
import { ArrowDown } from '../../../../assets';
import { Accordion } from '../../../../components';
import {
  AccordionStyle,
  Colors,
  Fonts,
  appStatusSubtext,
  appStatusesText,
  applicationStatusColors,
  appTermText
} from '../../../../constants';
import {
  useIsMobile
} from '../../../../recoil';

const styles = {
  accordionRightDiv: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '95%'
  },
  subTitle: {
    marginTop: 22,
    width: '100%',
    fontFamily: Fonts.Roboto,
    fontSize: '1em',
    lineHeight: '140%',
    color: Colors.GreyScale13
  },
  bodyWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%'
  },
  applicationDetailsContainer: {
    marginTop: 22,
    display: 'flex',
    flexGrow: 0.35,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  applicationDetails: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10
  },
  applicationDetailsKey: {
    display: 'flex',
    color: Colors.GreyScale7,
    marginBottom: 10,
    fontSize: '1em',
    fontFamily: Fonts.Roboto,
    minWidth: 150
  },
  applicationDetailsValue: {
    fontSize: '1.125em',
    fontFamily: Fonts.Roboto,
    color: Colors.GreyScale13,
    marginRight: 10
  },
  accordionBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
};

const formatCurrencyWithSpace = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const ApplicationAccordion = ({
  applicationData,
  isOpen,
  toggleOpen,
  businessNameForApp
}) => {
  const appProductName = `${businessNameForApp}: ${applicationData?.productName}`;
  const isMobile = useRecoilValue(useIsMobile);
  const applicationDetailsStyle = useMemo(() => isMobile ? { ...styles.applicationDetails, flexDirection: 'row' , fontSize: '14px'} : styles.applicationDetails, [isMobile]);
  const applicationDetailsKeyStyle = useMemo(() => isMobile ? { ...styles.applicationDetailsKey, fontSize: '14px' } : styles.applicationDetailsKey, [isMobile]);
  const pendingStatusStyle = useMemo(() => ({ ...AccordionStyle.pendingStatus, paddingRight: '20px', background: applicationStatusColors[applicationData?.applicationStatus] || Colors.AccentPurple5 }), [applicationData]);
  const accordionBodyStyle = useMemo(() => isMobile ? { ...styles.accordionBody, marginLeft: '20px' , marginRight: '20px'} : styles.accordionBody, [isMobile]);
  const bodyWrapperStyle = useMemo(() => !isMobile ? { ...styles.bodyWrapper, paddingLeft: '25px'} : styles.bodyWrapper, [isMobile]);
  const subTitleStyle = useMemo(() => !isMobile ? { ...styles.subTitle, paddingLeft: '25px'} : styles.subTitle, [isMobile]);
  const statusTxtStyle = useMemo(() => isMobile ? { ...AccordionStyle.statusTxt, paddingRight: '10px'} : AccordionStyle.statusTxt, [isMobile]);
  return (
    <>
      {applicationData && (
        <Accordion
          containerStyle={{ borderRadius: 16, paddingTop: 15, paddingBottom: 15 }}
          isOpen={isOpen}
          headerChildren={
            <>
              <div style={{ ...AccordionStyle.accordionHeaderLeft, maxWidth: '100%' }}>
                <div style={AccordionStyle.accordionTitle}>
                  {isOpen ? (applicationData?.productName) : appProductName }
                </div>
              </div>

              <div style={AccordionStyle.accordionHeaderRight}>
                <div style={styles.accordionRightDiv}>
                  <div style={pendingStatusStyle}>
                    <div style={AccordionStyle.statusEllipse} />
                    <div style={statusTxtStyle}>
                      {appStatusesText[applicationData?.applicationStatus] || 'Pending'}
                    </div>
                  </div>
                </div>
                <img
                  style={{ ...AccordionStyle.ArrowImg, rotate: isOpen ? '180deg' : '' }}
                  src={ArrowDown}
                  alt='DropdownOpen'
                  role='presentation'
                  onClick={() => toggleOpen?.()}
                  onKeyDown={() => toggleOpen?.()}
                />
              </div>
            </>
          }
        >
          <div style={AccordionStyle.accordionChildren}>
            <div style={accordionBodyStyle}>

              <div style={subTitleStyle}>
                {appStatusSubtext[applicationData?.applicationStatus] || 'Our team is currently reviewing your application and you should receive feedback within 48 hours.'}
              </div>
              {applicationData?.applicationStatus !== 'Declined' &&
              <div style={bodyWrapperStyle}>

                <div style={styles.applicationDetailsContainer}>
                  <div style={applicationDetailsStyle}>
                    <div style={applicationDetailsKeyStyle}>
                      Date
                    </div>
                    <div style={styles.applicationDetailsValue}>
                      {dayjs(applicationData?.applicationDate).format('DD/MM/YY')}
                    </div>
                  </div>
                  <div style={applicationDetailsStyle}>
                    <div style={applicationDetailsKeyStyle}>
                      Amount
                    </div>
                    <div style={styles.applicationDetailsValue}>
                      R {formatCurrencyWithSpace(applicationData?.amount)}
                    </div>
                  </div>
                  <div style={applicationDetailsStyle}>
                    <div style={applicationDetailsKeyStyle}>
                      Term(months)
                    </div>
                    <div style={styles.applicationDetailsValue}>
                      {appTermText[applicationData?.term]}
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </Accordion>
      )}
    </>
  );
};

ApplicationAccordion.propTypes = {
  isOpen: PropTypes.bool,
  toggleOpen: PropTypes.func,
  applicationData: PropTypes.object,
  businessNameForApp: PropTypes.string
};